import { Close } from "@mui/icons-material";
import {
  FormControl,
  IconButton,
  InputLabel,
  Select as MUISelect,
  SelectProps,
} from "@mui/material";
import { flushSync } from "react-dom";

type Props = SelectProps & {
  onValueChange: (v: any) => void;
  clearable?: boolean;
};

const Select = ({
  onValueChange,
  label,
  clearable = false,
  sx,
  MenuProps,
  ...rest
}: Props) => {
  const paperSx = MenuProps?.PaperProps?.sx;

  return (
    <div className="relative w-full">
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">{label}</InputLabel>
        <MUISelect
          label={label}
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          {...rest}
          MenuProps={{
            ...MenuProps,
            PaperProps: {
              ...MenuProps?.PaperProps,
              sx: [
                {
                  "& .MuiMenuItem-root": {
                    fontSize: 13,
                    minHeight: 36,
                    whiteSpace: "normal",
                  },
                },
                ...(Array.isArray(paperSx)
                  ? paperSx
                  : paperSx
                    ? [paperSx]
                    : []),
              ],
            },
          }}
          sx={[
            {
              "& .MuiSelect-select": {
                alignItems: "center",
                display: "flex",
                fontSize: 13,
                minHeight: "1.5em",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              "& .MuiInputLabel-root": {
                fontSize: 13,
              },
            },
            ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
          ]}
          onChange={(e) =>
            flushSync(() => {
              onValueChange(e.target.value);
            })
          }
          className={`${rest.value && clearable ? "pr-6" : ""}`}
        />
      </FormControl>
      {clearable && (
        <div
          className={`absolute top-1/2 -translate-y-1/2 right-6 !w-auto ${
            rest.value ? "block" : "hidden"
          }`}
        >
          <IconButton
            size="small"
            onClick={() =>
              flushSync(() => {
                onValueChange("");
              })
            }
          >
            <Close className="!text-lg" />
          </IconButton>
        </div>
      )}
    </div>
  );
};

export default Select;
